"use client";
import LoginWithNumber from "@/components/login/LoginWithNumber";
import useSoftSettingLogo from "@/hooks/useSoftSettingLogo";
import Image from "next/image";
import Link from "next/link";
import Skeleton from "react-loading-skeleton";

function Login() {
  //  Api  Hook  //
  const { data, isLoading } = useSoftSettingLogo();
  return (
    <>
      {/* Login Template */}
      <div className="bg-ws-gray h-screen-footer">
        <div className="h-screen-footer flex flex-col justify-center bg-ws-white-100">
          <div className="login-wrapper flex justify-between p-2">
            <div className={`w-full`}>
              <div className="form-wrapper flex flex-col justify-center items-center p-8 px-24">
                {/* Iamges Of Login */}

                {isLoading ? (
                  <Skeleton width={120} height={120} borderRadius={15} />
                ) : (
                  <Link href="/">
                    <Image
                      width={500}
                      height={300}
                      priority
                      unoptimized
                      fetchPriority="high"
                      className="w-auto h-30 mb-5"
                      src={
                        `${process.env.NEXT_PUBLIC_ADMIN_URL}${data}`
                          ? `${process.env.NEXT_PUBLIC_ADMIN_URL}${data}`
                          : "/images/default.png"
                      }
                      alt="login-logo"
                    />
                  </Link>
                )}

                {/* Login With Number Form */}
                <LoginWithNumber />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
